var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSubscripe(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 35.2,
    height: 32,
    viewBox: "0 0 35.2 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M24.357 12.32a9.29 9.29 0 1 0 0 18.578 9.29 9.29 0 0 0 0-18.579Zm.461 13.792.005.656a.168.168 0 0 1-.165.168h-.59a.166.166 0 0 1-.165-.166v-.65c-1.842-.138-2.709-1.187-2.802-2.326a.166.166 0 0 1 .166-.181h.957c.08 0 .152.058.165.136.106.658.618 1.149 1.536 1.272v-2.96l-.512-.13c-1.085-.259-2.117-.936-2.117-2.336 0-1.512 1.149-2.325 2.616-2.469v-.683c0-.091.075-.166.166-.166h.582c.091 0 .166.075.166.166v.678c1.419.142 2.485.971 2.61 2.264a.165.165 0 0 1-.165.182h-.931a.166.166 0 0 1-.165-.144c-.083-.605-.568-1.099-1.357-1.206v2.784l.526.123c1.344.331 2.256.974 2.256 2.413 0 1.562-1.16 2.432-2.784 2.573Zm-2.232-6.613c0 .526.325.934 1.026 1.187.098.04.195.07.312.104v-2.571c-.766.098-1.338.528-1.338 1.28Zm2.416 2.803a3.037 3.037 0 0 1-.182-.046v2.773c.883-.08 1.493-.565 1.493-1.376 0-.637-.331-1.051-1.312-1.35Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8.878.774a.95.95 0 0 1 .278.672v.95h15.2v-.95a.95.95 0 1 1 1.899 0v.95h1.901a3.8 3.8 0 0 1 3.8 3.8v1.901h-30.4v-1.9a3.8 3.8 0 0 1 3.8-3.8h1.899v-.951A.95.95 0 0 1 8.88.774Zm9.624 30.122a10.978 10.978 0 1 1 13.453-17.211V9.998h-30.4v17.101a3.8 3.8 0 0 0 3.802 3.8h13.146Z",
    fill: "#fff"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSubscripe);
export default __webpack_public_path__ + "static/media/subscripe.3109174a.svg";
export { ForwardRef as ReactComponent };